import accountDetailsEN from "./accountDetails.json";
import addressEN from "./address.json";
import alertsEN from "./alerts.json";
import barringsEN from "./barrings.json";
import billsEN from "./bills.json";
import footerEN from "./footer.json";
import forgotEmailEN from "./forgotEmail.json";
import glossaryEN from "./glossary.json";
import navigationEN from "./navigation.json";
import orderEN from "./order.json";
import paymentEN from "./payment.json";
import portinEN from "./portin.json";
import profileEN from "./profile.json";
import simEN from "./sim.json";
import controlEN from "./control.json";
import commonEN from "./common.json";
import headerEN from "./header.json";
import monthEN from "./month.json";
import usageEN from "./usage.json";
import validationEN from "./validation.json";
import cancelBroadbandEN from "./cancelBroadband.json";
import addonsEN from "./addons.json";
import appointmentEN from "./appointment.json";
import recommendationBannerEN from "./recommendationBanner.json";

export const address = addressEN;

export const alerts = alertsEN;

export const barrings = barringsEN;

export const bills = billsEN;

export const control = controlEN;

export const common = commonEN;

export const footer = footerEN;

export const glossary = glossaryEN;

export const header = headerEN;

export const forgotEmail = forgotEmailEN;

export const navigation = navigationEN;

export const accountDetails = accountDetailsEN;

export const order = orderEN;

export const payment = paymentEN;

export const portin = portinEN;

export const profile = profileEN;

export const sim = simEN;

export const month = monthEN;

export const usage = usageEN;

export const validation = validationEN;

export const cancelBroadband = cancelBroadbandEN;

export const addons = addonsEN;

export const appointment = appointmentEN;

export const recommendationBanner = recommendationBannerEN;
